import './kiosk/index'

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then(async registration => {
      await navigator.serviceWorker.ready;
      const controller = navigator.serviceWorker.controller;
      if (controller && controller.scriptURL.endsWith('/service-worker.js')) return;
      const worker = registration.active || registration.waiting || registration.installing;
      if (worker) {
        if (worker.state === 'activated') window.location.reload();
        else worker.addEventListener('statechange', () => {
          if (worker.state === 'activated') window.location.reload();
        }, {once: true});
      }
    }).catch(() => {});
  })
}
